import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  mobile: ".animation--container > *",
  desktop: ".animation--item"
};

export default node => {
  // Add the animation delay offset variables
  delayOffset(node, [selectors.mobile]);
  delayOffset(node, [selectors.desktop]);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
